import useSwr from "@/core/composables/swr/useSwr";
import {customerApi} from "@/container";

/**
 * Composable to fetch a customer.
 */
const useCustomer = (customerId?: number) => {
    return useSwr(
        customerId ? `customers/${customerId}` : null,
        customerId
            ? () => customerApi().read(customerId)
            : () => Promise.resolve(undefined)
    );
};

export default useCustomer;
